const stripComments = code => {
  return code.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "")
}

/**
 * Parse filter code to extract variable keys from Variables.set() calls.
 * Ignores Variables.set() calls inside comments.
 * @param {string} filterCode - The filter code to parse
 * @returns {string[]} - Array of unique variable key names
 */
export const parseFilterCodeVariables = (filterCode, maxVariables = 20) => {
  if (!filterCode) return []

  const codeWithoutComments = stripComments(filterCode)
  const variablesSetRegex = /Variables\.set\s*\(\s*["']([^"']+)["']/g
  const keys = new Set()

  for (const match of codeWithoutComments.matchAll(variablesSetRegex)) {
    keys.add(match[1])
    if (keys.size >= maxVariables) break
  }

  return Array.from(keys)
}
